<template>
  <!-- <overall-result /> -->
  <div>
    <div class="printBtn">
      <v-btn color="primary" fab small dark @click="downloadWithCSS">
        <v-icon>mdi-printer</v-icon>
      </v-btn>
    </div>
    <div class="result__card-wrap" ref="content">
      <div class="graphs__card">
        <div class="graphs__card-header">
          <v-alert color="blue-grey" dark dense icon="mdi-chart-bar" prominent>
            Comparative analysis of Residential Envelope Transmittance Value (RETV)
          </v-alert>
        </div>

        <div class="graphs__card-wrap">
          <div class="graphs-row1">
            <div class="--m2">
              <project-retv-graph class="charts-shadow" />
            </div>
            <div class="--m2">
              <project-term-wise-retv class="charts-shadow" />
            </div>
          </div>
        </div>
      </div>
      <!-- Card 2 -->
      <div class="graphs__card">
        <div class="graphs__card-header">
          <v-alert color="blue-grey" dark dense icon="mdi-chart-bar" prominent>
            Comparative analysis of thermal transmittance and SHGC Unshaded
          </v-alert>
        </div>
        <div class="graphs__card-wrap">
          <div class="graphs-row1">
            <div class="--m2">
              <project-roof-graph class="charts-shadow" />
            </div>
            <div class="--m2">
              <project-wall-graph class="charts-shadow" />
            </div>
          </div>
          <div class="graphs-row1">
            <div class="--m2">
              <project-glass-graph class="charts-shadow" />
            </div>
            <div class="--m2">
              <project-shgc-graph class="charts-shadow" />
            </div>
          </div>
        </div>
      </div>
      <div class="tr-result-card">
        <div class="result-card-header">
          <div>Result: Project 1</div>
        </div>
        <div class="result__card-content-container">
          <div class="result__subheader-row">
            <div>Inputs</div>
            <div class="last-item">Project 1</div>
          </div>
          <div class="result__card-row">
            <div class="result__input-label">Project Name :</div>
            <div class="result__input-value">{{ schema.inputs.step1.project_name || `----` }}</div>
          </div>
          <!--Client name  -->
          <div class="result__card-row">
            <div class="result__input-label">Client Name :</div>
            <div class="result__input-value">{{ schema.inputs.step1.client_name || `----` }}</div>
          </div>
          <!-- Designed by -->
          <div class="result__card-row">
            <div class="result__input-label">Designed by :</div>
            <div class="result__input-value">{{ schema.inputs.step1.designed_by || `----` }}</div>
          </div>
          <!--  -->
          <div class="result__card-row">
            <div class="result__input-label">Project Location :</div>
            <div class="result__input-value">{{ schema.inputs.step1.project_location || `----` }}</div>
          </div>
          <!--  -->
          <div class="result__card-row">
            <div class="result__input-label">Latitude :</div>
            <div class="result__input-value">{{ schema.inputs.step1.latitude.name || `----` }}</div>
          </div>
          <!--  -->
          <div class="result__card-row">
            <div class="result__input-label">Climate Zone :</div>
            <div class="result__input-value">{{ schema.inputs.step1.climate_zone || `----` }}</div>
          </div>
          <!--  -->
          <div class="result__card-row">
            <div class="result__input-label">Surface Area Wall(sq.m) :</div>
            <div class="result__input-value">{{ schema.inputs.step2.summary_step2.surface_area_wall || `----` }}</div>
          </div>
          <!--  -->
          <div class="result__card-row">
            <div class="result__input-label">WWR% (only glass) :</div>
            <div class="result__input-value">{{ (schema.inputs.step4.vltObj.window_wall_ratio * 100).toFixed(2) }}</div>
          </div>
          <div class="result__card-row">
            <div class="result__input-label">Roof Construction Assembly :</div>
            <div class="result__input-multivalue">
              <div v-for="(roof, l) in schema.inputs.step5A.thermal_trans_roof" class="result__input-value">
                <div v-if="roof.material_n_resistance">
                  <ul>
                    <li style="list-style-type:circle;">{{ roof.material_n_resistance.material || `----` }}</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <!--  -->
          <div class="result__card-row">
            <div class="result__input-label">Wall Construction Assembly :</div>
            <div class="result__input-multivalue">
              <div v-for="(wall, l) in wallConstructionAssembly" class="result__input-value">
                <ul>
                  <li style="list-style-type:circle;">
                    {{ wall || `----` }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- </div> -->
          <!-- </div> -->

          <!--  -->
          <div class="result__card-row">
            <div class="result__input-label">Door Frame Construction :</div>
            <div class="result__input-multivalue">
              <div v-for="(door, l) in schema.inputs.step5B.thermal_trans_doors" class="result__input-value">
                <div v-for="layerObj in door.layer_arr_obj">
                  <div v-if="layerObj.material_n_resistance">
                    {{ layerObj.material_n_resistance.material || `----` }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--  -->
          <!--  -->
          <div class="result__card-row">
            <div class="result__input-label">Window Frame Construction :</div>
            <div class="result__input-multivalue">
              <div v-for="(window, l) in schema.inputs.step5B.thermal_trans_windows" class="result__input-value">
                <div v-for="layerObj in window.layer_arr_obj">
                  <div v-if="layerObj.material_n_resistance">
                    {{ layerObj.material_n_resistance.material || `----` }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--  -->
          <div class="result__card-row">
            <div class="result__input-label">Glazing Selection :</div>
            <div class="result__input-multivalue">
              <div v-for="glazing in glazingSelection" class="result__input-value">
                <ul>
                  <li style="list-style-type: circle;">
                    {{ glazing }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!--  -->
          <!--  -->
          <div class="result__card-row">
            <div class="result__input-label">Shading Selection :</div>
            <div class="result__input-multivalue">
              <span style="width:100%; font-weight:520;">
                Window
              </span>

              <div v-for="shading in windowShadingData" class="result__input-value">
                <ul>
                  <li style="list-style-type:circle;">
                    {{ shading }}
                  </li>
                </ul>
              </div>
              <hr />
              <span class="shading-classification">
                Ventilator
              </span>

              <div v-for="shading in ventiShadingData" class="result__input-value">
                <ul>
                  <li style="list-style-type:circle;">
                    {{ shading }}
                  </li>
                </ul>
              </div>
            </div>
            <!-- <div v-for="(window, j) in step3B.windowTypeArrObj">
          <div v-for="(orient, k) in step3B.windowTypeArrObj[j].orientationObj" :key="orient.orientation + k + j">
            <div v-if="orient.calcOpenableArea !== 0 && orient.calcOpenableArea !== ''">
              <div class="result__input-value">{{ orient.selectedShading.title }}</div>
            </div>
          </div>
        </div> -->
          </div>
          <!--  -->
        </div>
        <!--  -->
        <div class="result__card-conclusion">
          <div class="conclusion-header">Conclusion</div>
          <div class="conclusion-row">
            <span class="label">WFR (openable)% :</span>
            <span class="value" :class="{ '--invalid': step4.wfropObj.wfropPercent < step4.wfropObj.minWfropPercent }"> {{ schema.inputs.step4.wfropObj.wfropPercent }}</span>
          </div>
          <div class="conclusion-row">
            <span class="label">VLT (recommended):</span>
            <span class="value">{{ schema.inputs.step4.vltObj.required_vlt }}</span>
          </div>
          <div class="conclusion-row">
            <span class="label">Uroof (W/m<sup>2</sup>.K):</span>
            <span class="value" :class="{ '--invalid': step5A.roof_u_value > 1.2 }"> {{ schema.inputs.step5A.roof_u_value }}</span>
          </div>
          <div class="conclusion-row">
            <span class="label">RETV (W/m<sup>2</sup>):</span>
            <span class="value" :class="{ '--invalid': retv6C.retv > 15 }">{{ retv6C.retv }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProjectRetvGraph from '@/components/Graphs/Result/ProjectRetvGraph.vue';
import ProjectTermWiseRetv from '@/components/Graphs/Result/ProjectTermWiseRetv.vue';
import ProjectRoofGraph from '@/components/Graphs/Result/ProjectRoofGraph.vue';
import ProjectWallGraph from '@/components/Graphs/Result/ProjectWallGraph.vue';
import ProjectGlassGraph from '@/components/Graphs/Result/ProjectGlassGraph.vue';
import ProjectShgcGraph from '@/components/Graphs/Result/ProjectShgcGraph.vue';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import domtoimage from 'dom-to-image';
export default {
  components: {
    ProjectRetvGraph,
    ProjectTermWiseRetv,
    ProjectRoofGraph,
    ProjectWallGraph,
    ProjectGlassGraph,
    ProjectShgcGraph,
  },
  computed: {
    schema: {
      get: function() {
        return this.$store.state.schema;
      },
      set: function(newSchema) {
        this.$store.dispatch('setSchema', newSchema);
      },
    },
    step3B: {
      get: function() {
        return this.$store.state.schema.inputs.step3B;
      },
      set: function(step3B) {
        this.$store.dispatch('setStep3B', step3B);
      },
    },
    step4: {
      get: function() {
        return this.$store.state.schema.inputs.step4;
      },
      set: function(step4) {
        this.$store.dispatch('setStep4', step4);
      },
    },
    step3C: {
      get: function() {
        return this.$store.state.schema.inputs.step3C;
      },
      set: function(step3B) {
        this.$store.dispatch('setStep3C', step3C);
      },
    },
    step5A: {
      get: function() {
        return this.$store.state.schema.inputs.step5A;
      },
      set: function(step5A) {
        this.$store.dispatch('setStep5A', step5A);
      },
    },
    retv6B: {
      get: function() {
        return this.$store.state.schema.inputs.retv6B;
      },
      set: function(retv6B) {
        this.$store.dispatch('setRetv6B', retv6B);
      },
    },
    retv6C: {
      get: function() {
        return this.$store.state.schema.inputs.retv6C;
      },
      set: function(retv6C) {
        this.$store.dispatch('setRetv6C', retv6C);
      },
    },
    projects: {
      get: function() {
        // console.log('Wall Index', this.wallIndex);
        console.log(this.$store.state.projects);
        return this.$store.state.projects;
      },
      set: function(Project) {
        this.$store.dispatch('setProjects', Project);
      },
    },
    glazingSelection() {
      const glazingSet = new Set();
      this.step3B.windowTypeArrObj[0].orientationObj.forEach(orient => {
        if (orient.calcOpenableArea !== 0 && orient.calcOpenableArea !== '') {
          if (orient.selectedNonOpaqueMaterial && orient.selectedNonOpaqueMaterial.material) {
            glazingSet.add(orient.selectedNonOpaqueMaterial.material);
            console.log('glazing', glazingSet);
          }
        }
      });
      this.schema.glazingSelectionData = Array.from(glazingSet);
      return glazingSet;
    },
    windowShadingData() {
      const windowShadingSet = new Set();
      this.step3B.windowTypeArrObj.forEach(window => {
        window.orientationObj.forEach(orient => {
          if (orient.calcOpenableArea !== 0 && orient.calcOpenableArea !== '') {
            if (orient.selectedShading && orient.selectedShading.title) {
              windowShadingSet.add(orient.selectedShading.title);
            }
          }
        });
      });

      this.schema.windowShadingData = Array.from(windowShadingSet);
      return windowShadingSet;
    },

    ventiShadingData() {
      const ventiShadingSet = new Set();

      this.step3C.ventilatorArrObj.forEach(venti => {
        if (venti.calcGlassArea !== 0) {
          if (venti.selectedShading && venti.selectedShading.title) {
            ventiShadingSet.add(venti.selectedShading.title);
          }
        }
      });
      this.schema.ventiShadingData = Array.from(ventiShadingSet);
      return ventiShadingSet;
    },
    wallConstructionAssembly() {
      const wallConstructionData = new Set();
      this.schema.inputs.step5B.thermal_trans_walls.forEach(wall => {
        wall.layer_arr_obj.forEach(layerObj => {
          if (layerObj.material_n_resistance) {
            wallConstructionData.add(layerObj.material_n_resistance.material);
          }
        });
      });
      this.schema.wallConstructionAssemblyData = Array.from(wallConstructionData);
      console.log('Wall Construction Assembly data', this.schema.wallConstructionAssemblyData);
      return wallConstructionData;
    },
  },
  mounted() {
    this.glazingSelection;
  },
  methods: {
    downloadWithCSS() {
      /** WITH CSS */
      domtoimage
        .toPng(this.$refs.content)
        .then(function(dataUrl) {
          var img = new Image();
          img.src = dataUrl;
          const doc = new jsPDF({
            orientation: 'portrait',
            // unit: "pt",
            format: [1400, 1000],
          });
          doc.addImage(img, 'JPEG', 20, 20);
          const date = new Date();
          const filename = 'timechart_' + date.getFullYear() + ('0' + (date.getMonth() + 1)).slice(-2) + ('0' + date.getDate()).slice(-2) + ('0' + date.getHours()).slice(-2) + ('0' + date.getMinutes()).slice(-2) + ('0' + date.getSeconds()).slice(-2) + '.pdf';
          doc.save(filename);
        })
        .catch(function(error) {
          console.error('oops, something went wrong!', error);
        });
    },
  },
};
</script>

<style lang="scss">
.result__card-wrap {
  margin-top: 76px;
}
.printBtn {
  position: absolute;
  right: 284px;
  margin: 16px;
  z-index: 2;
}
.graphs__card {
  background-color: #fff;
  margin-bottom: 12px;
  .graphs-row1 {
    display: flex;
    justify-content: space-evenly;
  }
  .graphs__card-header {
    background-color: #e1f3f1;
    // padding: 12px 4px 12px 4px;
    .heading {
      color: #0d9b8e;
    }
  }
  .--m2 {
    margin: 8px;
  }
}
.charts-shadow {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  border-radius: 4px;
}
.tr-result-card {
  background-color: #fff;
  // padding: 20px;
  border-radius: 4px;
  // height: 100%;
  // width: 100%;
  margin-top: 76px;
  margin-bottom: 44px;
}
.result-card-header {
  padding: 16px 24px;
  background-color: #5a6978;
  color: #fff;
  font-size: 24px;
  // margin: auto;
  text-align: center;
}
.result__card-content-container {
  padding: 20px;
  // display: flex;
  .result__subheader-row {
    background-color: #c4def5;
    padding: 12px 24px;
    color: #318ddd;
    font-size: 20px;
    text-align: left;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    display: flex;

    justify-content: space-between;
    .last-item {
      width: 240px;
    }
  }
}
.result__card-row {
  outline: 1px solid #dedede;

  display: flex;
  justify-content: space-around;
  padding: 6px;
  border-bottom: 1px solid #dedede;
  .result__input-label {
    width: 240px;
  }
  .result__shading--title {
    display: flex;
    flex-direction: column;
    td {
      border-bottom: 1px solid #dedede;
    }
  }
  .result__input-value {
    width: 240px;
  }
  .result__input-multivalue {
    // width: 240px;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
}

.shading-classification {
  border-top: 2px dashed #dedede;
  width: 100%;
  font-weight: 520;
}
.result__card-conclusion {
  padding: 20px;
}
.conclusion-header {
  background-color: #c4def5;
  color: #fff;
  font-size: 24px;
  padding: 12px 24px;
  color: #318ddd;
  font-size: 20px;
  text-align: center;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}

.conclusion-row {
  display: flex;
  justify-content: space-around;
  padding: 6px;
  border-bottom: 1px solid #dedede;
  outline: 1px solid #dedede;

  .label {
    width: 200px;
  }
  .value {
    width: 30%;
    text-align: center;
    padding: 4px;
    background-color: #c8f0e0;
    color: #2cb17c;
    border-radius: 4px;
  }
  .--invalid {
    background-color: #ffebeb;
    color: #ff6767;
  }
}
</style>
